import styled from 'styled-components';

export const MainContainer = styled.div`
    body {
        font-size: 12px;
        font-weight: bold;
        color: #2B3A54;
        max-height: 300; 
        overflow: auto;
    }

    label {
        cursor: pointer;
        user-select: none;
        padding: 2px;
        margin: 2px;
        color: #626E82;

        span {
            font-weight: bold;
            font-size: 14px;
            border: 1px solid #dce0e8;
            border-radius: 50px;
            transition: 0.4s;
            padding: 0 15px;
            height: 36px;
            color: #414141;
            display: flex;
            align-items: center;
            column-gap: 7px;
        }

        input {
            pointer-events: none;
            display: none;

            &:checked + span {
                background-color: #e2f4ef;
                border-color: #e2f4ef;
                color: #008561;
            }
        }
    }
`;
